var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import Anchor from '@telia-front/anchor';
import Grid, { GridColumn } from '@telia-front/grid';
import Icon from '@telia-front/icon';
import Image from '@telia-front/image';
const ServiceCardsItem = (props) => {
    const { icon, className, children } = props, anchorProps = __rest(props, ["icon", "className", "children"]);
    const BEM = () => {
        const classArray = ['service-cards__item'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const renderIcon = (icon) => {
        if (typeof icon === 'string') {
            return React.createElement(Icon, { modifiers: icon, align: "middle", className: "service-cards__icon" });
        }
        return React.createElement(Image, Object.assign({}, icon, { role: "presentation", className: "service-cards__icon" }));
    };
    return (React.createElement(Anchor, Object.assign({ isTextColor: true, isUnderlined: false }, anchorProps, { className: BEM() }),
        React.createElement(Grid, { align: ['center-xs'], horizontalGutter: "none", verticalGutter: "small", className: "service-cards__item-inner" },
            React.createElement(GridColumn, { align: ['middle-xs'], className: "service-cards__icon-wrapper", width: ['min'] }, renderIcon(icon)),
            React.createElement(GridColumn, { align: ['middle-xs'], className: "service-cards__content", width: ['max'] }, children))));
};
export { ServiceCardsItem as default };
